// extracted by mini-css-extract-plugin
export default {"root":"ProjectDetails_root__zD4jH"};